import React from "react";
import { connect } from "react-redux";

import StockGroup from "./Stock/group.js";
import { setBreadcrumbs } from "reducers/view";

class ProductItem extends React.Component {
  constructor() {
    super(...arguments);

    this.props.setBreadcrumbs([
      { name: "Products", slug: "/products" },
      {
        name: `Product: ${this.currentItem.name}`,
        slug: `/products/${this.currentId}`,
      },
    ]);
  }

  get currentId() {
    return this.props.match.params.id ?? null;
  }

  get currentItem() {
    return this.props.product.find((item) => item.id === this.currentId);
  }

  render() {
    const product = this.currentItem;

    if (this.currentItem) {
      return (
        <React.Fragment>
          <h1>{product.name}</h1>
          <StockGroup {...this.props} product={product} />
        </React.Fragment>
      );
    }
    return null;
  }
}

export default connect(
  (state) => {
    return {
      product: state.product.all,
    };
  },
  { setBreadcrumbs }
)(ProductItem);
